import { CatalogService } from './CatalogService';

export class AnalyticsTypeOfActivePassiveItemService extends CatalogService {
    async Clone(id: string) {
        const newObject = await this.Get(id);
        const clonedObject = { ...newObject };
        console.log('clonedObject is', clonedObject)
        return clonedObject;
    }
}
